// extracted by mini-css-extract-plugin
export var actionButton = "_ex-t";
export var buttonContainer = "_ex-0";
export var buttonContainer2 = "_ex-1";
export var buttonSection = "_ex-2";
export var details = "_ex-3";
export var dropdownItem = "_ex-5";
export var dropdownItemsContainer = "_ex-4";
export var fileInput = "_ex-r";
export var headerButton = "_ex-6";
export var icon = "_ex-7";
export var input = "_ex-8";
export var macroListItem = "_ex-9";
export var mainContent = "_ex-a";
export var microText = "_ex-b";
export var modal = "_ex-w";
export var optionsButton = "_ex-c";
export var paperclip = "_ex-s";
export var pillContent = "_ex-d";
export var preview = "_ex-e";
export var preview2 = "_ex-f";
export var quillEditor = "_ex-q";
export var selectedMacro = "_ex-g";
export var sidebar = "_ex-h";
export var sidebarHeader = "_ex-j";
export var sidebarList = "_ex-i";
export var sidebarListItem = "_ex-k";
export var sidebarSearch = "_ex-l";
export var snoozeDurationWrapper = "_ex-v";
export var statusPillContainer = "_ex-m";
export var tagsContainer = "_ex-n";
export var unselectedMacro = "_ex-o";
export var variable = "_ex-u";
export var wrapper = "_ex-p";